export default {
  selectDefault: {
    width: 300
  }
};
